import { AfterViewInit, Component, Input, OnChanges, OnDestroy, OnInit } from '@angular/core'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { Subscription } from 'rxjs'
import { ApiService } from '../api.service'
import { Course } from '../types/course'
import Swal from 'sweetalert2'

@Component({
	selector: 'course-form',
	templateUrl: './course-form.component.html',
	styleUrls: ['./course-form.component.scss']
})

export class CourseFormComponent implements OnInit, AfterViewInit, OnChanges, OnDestroy {

	@Input() id = 0
	@Input() name = ''
	@Input() hours = 0
	@Input() category = 0
	@Input() translations: string[] = ['es']
	@Input() edit = false
	@Input() dialog = false
	categories: any[] = []
	
	pdf = false
	units: any[] = []
	extractPDFInfoLoading = false
	extractPDFInfoSuccess = false
	extractPDFInfoError = false

	courseFormGroup: FormGroup
	courseFormState: 'idle' | 'submitting' | 'success' | 'error' = 'idle'
	courseFormErrors: any[] = []

	getCategoriesSub = new Subscription
	courseFormSub = new Subscription
	extractPDFInfoSub = new Subscription

	constructor(private dataService: ApiService, private formBuilder: FormBuilder) {
		this.courseFormGroup = this.formBuilder.group({
			id: 			[0, 	Validators.required],
			name: 			['',	Validators.required],
			hours:	 		[0, 	[Validators.required, Validators.min(1)]],
			category: 		[0,		[Validators.required, Validators.min(1)]],
			translations:	[[], 	Validators.required],
		})
	}

	ngOnInit(): void {}

	ngAfterViewInit(): void {
		if (!this.edit) {
			this.getCategoriesSub = this.dataService.getCategories()
			.subscribe({
				next: (data) => {
					console.log(data)
					this.categories = data
				},
				error: (e) => {
					console.log(e)
				},
			})
		}

		if (this.id != 0) {
			this.courseFormGroup.patchValue({
				id: this.id,
				name: this.name,
				hours: this.hours,
				category: this.category,
				translations: this.translations,
			})
		} else {
			this.courseFormGroup.reset({
				id: 0,
				name: '',
				hours: 0,
				category: this.category,
				translations: ['es'],
			})
		}
	}

	ngOnChanges(): void {}

	ngOnDestroy(): void {
		this.getCategoriesSub?.unsubscribe()
		this.courseFormSub?.unsubscribe()
	}

	updateTranslations(target: EventTarget | null) {
		const input = target as HTMLInputElement
		const value = input.value

		if (input.checked) {
			if (!this.translations.includes(value)) this.translations.push(value)
		} else {
			const index = this.translations.indexOf(value)
			if (index != -1) this.translations.splice(index, 1)
		}
	}

	extractPDFInfo(target: EventTarget | null) {
		// console.log(target)
		const input = target as HTMLInputElement
		let file = input.files?.item(0)!
		console.log(file)

		let type = file.type
		if (type != "application/pdf") {
			Swal.fire('Error', 'Por favor, suba un archivo PDF.', 'error')
			return
		}

		let reader = new FileReader()
		reader.readAsDataURL(file)
		reader.onload = () => {

			this.extractPDFInfoLoading = true
			this.extractPDFInfoSuccess = false
			this.extractPDFInfoError = false

			let file_b64 = reader.result!.toString()
			this.extractPDFInfoSub = this.dataService.extractPDFInfo(file_b64)
			.subscribe(
				data => {
					console.log(data)

					this.extractPDFInfoSuccess = true
					this.extractPDFInfoLoading = false
					this.extractPDFInfoError = false

					this.pdf = false
					this.name = data.name
					this.hours = data.hours
					this.units = data.units
				},
				error => {
					console.log(error)
					this.extractPDFInfoError = true
					this.extractPDFInfoLoading = false
					this.extractPDFInfoSuccess = false
				},
			)
		}
	}

	courseFormSubmit() {
		if (this.courseFormState != 'idle') return

		this.courseFormErrors = []
		if (!this.courseFormGroup.valid) {
			// console.log(this.courseFormGroup)

			if (this.courseFormGroup.get('name')?.errors != null) {
				this.courseFormErrors.push('El nombre del curso no puede estar vacío.')
			}

			if (this.courseFormGroup.get('hours')?.errors != null) {
				this.courseFormErrors.push('El número de horas debe ser mayor a 0.')
			}

			if (this.courseFormGroup.get('category')?.errors != null) {
				this.courseFormErrors.push('Por favor, seleccione una categoría.')
			}

			this.courseFormState = 'error'
			return
		}

		let formCourseID = this.courseFormGroup.value.id
		let formCourse = new Course()
		formCourse.id = formCourseID
		formCourse.name = this.courseFormGroup.value.name
		formCourse.hours = this.courseFormGroup.value.hours
		formCourse.category = this.courseFormGroup.value.category
		formCourse.translations = this.translations

		this.courseFormState = 'submitting'
		if (this.edit) {
			this.courseFormSub = this.dataService.editCourse(formCourse)
			.subscribe({
				next: (result) => {
					console.log(result)
					this.courseFormState = 'success'
					setTimeout(() => {
						window.location.reload()
					}, 2000)
				},
				error: (e) => {
					console.log(e)
					this.courseFormState = 'error'
				}
			})
		} else {
			this.courseFormSub = this.dataService.generateBlankCourse(formCourse)
			.subscribe({
				next: (result) => {
					console.log(result)
					this.id = result
					this.courseFormState = 'success'
				},
				error: (e) => {
					console.log(e)
					this.courseFormState = 'error'
				}
			})
		}
	}

	goToNewCourse() {
		window.location.href = '/course/' + this.id
		return false
	}

}
